// audioPlayer.js
const audio = new Audio("/ganesh.mp3");
audio.loop = true;

export default audio;
